var map = {
	"./Dailogo.png": 84820,
	"./Roadmap.png": 98995,
	"./Symbol.png": 25399,
	"./Tokenomics 2.png": 78947,
	"./Tokenomics2.svg": 23773,
	"./about1.png": 14223,
	"./about3.png": 29245,
	"./ast.svg": 29293,
	"./bannershadow.svg": 65881,
	"./bbb.png": 86021,
	"./bg-banner.png": 29083,
	"./bg-image.svg": 16574,
	"./bi_facebook.png": 16541,
	"./big-gradient.svg": 41600,
	"./brand1.png": 30351,
	"./brand2.png": 8884,
	"./brand3.png": 30013,
	"./brand4.png": 84642,
	"./brand5.png": 58795,
	"./buyimg.svg": 24186,
	"./bxs_up-arrow.png": 84292,
	"./c1.png": 11043,
	"./c2.png": 25768,
	"./c3.png": 23633,
	"./c5.png": 935,
	"./card1.svg": 15146,
	"./card2.svg": 64441,
	"./card3.svg": 52072,
	"./card_bg_t.png": 5302,
	"./cat.svg": 84185,
	"./circle.png": 85919,
	"./circle_b.png": 62120,
	"./desktop_views.png": 17824,
	"./discord.svg": 3345,
	"./email.png": 60003,
	"./exodus.svg": 14149,
	"./faq1.png": 53810,
	"./faq2.png": 18345,
	"./faqdown.svg": 56553,
	"./footer_logo.jpeg": 95987,
	"./footer_logo.png": 26274,
	"./footer_logo1.png": 23745,
	"./footerborder.svg": 34684,
	"./free-reddit-logo-icon-2436-thumb 1.png": 34570,
	"./global-business.png": 4831,
	"./header-top.svg": 1270,
	"./hero.png": 9227,
	"./hero1.png": 87418,
	"./hero2.png": 12081,
	"./i.fas.png": 70814,
	"./insta.png": 32346,
	"./insta.svg": 54676,
	"./jok.svg": 55241,
	"./king.svg": 15814,
	"./left_image.png": 73822,
	"./left_line.png": 30779,
	"./lines_b.png": 60725,
	"./linkedin.png": 95405,
	"./logo.png": 82806,
	"./mash_right.png": 71027,
	"./mdi_twitter.png": 55183,
	"./mesh-testimonials-blockchain.png": 55668,
	"./metamask.svg": 88884,
	"./mingcute_youtube-fill.png": 95089,
	"./mission.png": 98673,
	"./mission1.png": 54076,
	"./navLogo.svg": 59851,
	"./nft1.svg": 93038,
	"./nft2.svg": 25037,
	"./nft3.svg": 42444,
	"./nft4.svg": 76339,
	"./pajamas_twitter.png": 66244,
	"./piechart.svg": 98061,
	"./pinkgradient.svg": 18475,
	"./profile.jpg": 61120,
	"./reddit.png": 56071,
	"./right_line.png": 72924,
	"./road.png": 74961,
	"./road_map_mobile.png": 71537,
	"./roadmap.svg": 71741,
	"./roadmapImgNew.png": 62974,
	"./roadmapUpdateImg.svg": 79159,
	"./rshadow.svg": 4063,
	"./safepal.svg": 39411,
	"./stackdownarrow.svg": 58172,
	"./stake_logo.png": 97123,
	"./team1.png": 7683,
	"./team2.png": 70824,
	"./team_bg.png": 71276,
	"./tele.svg": 35899,
	"./telegram.png": 5970,
	"./tikdogslogo.svg": 52381,
	"./tiktok.svg": 53501,
	"./token.png": 59860,
	"./tokens.png": 43685,
	"./tokens_b.png": 88854,
	"./trust-wallet.svg": 91075,
	"./twit.svg": 73623,
	"./twitter.png": 82662,
	"./uil_instagram-alt.png": 29662,
	"./usdt.png": 79199,
	"./user.png": 5314,
	"./ustdicon.svg": 39632,
	"./vision.png": 62187,
	"./vision1.png": 55002,
	"./walletconnect.svg": 8282,
	"./whitepaper.pdf": 85716,
	"./x.png": 73035,
	"./youtube.svg": 36046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;